import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import React, { useState, useEffect } from "react";
import { PaginationProps } from "antd/es/pagination";
import { ISaleRoStatistics, ISaleRoList, ISaleRoDetail, ISaleRoSearch, Ids, Detailed, ISaleRoSettleAndWhConfirm } from "./saleRoTypes"
import { saleRoService } from "./saleRoService"
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { customerService, IMdCustomerDetail, IMdCustomerSearchField } from "../../../base/customer/customerService";
import { message } from "antd";
import { transPgToPagination, formatNum } from "@/utils/utils";
import { convertRes2Blob } from "@/utils/exportFile";



export const useSaleRoModel = createModel(function () {
    const initSearchParam: ISaleRoSearch = {};
    const initDataSource: ISaleRoDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initDesc: ISaleRoStatistics = {
        amount: 0,
        amountReceived: 0,
        totalAmount: 0,
        totalNum: 0
    }
    //查询条件
    const [searchParam, setSearchParam] = useState<ISaleRoSearch>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<ISaleRoDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    //表格选中的值
    const [selectedRow, setSelectedRow] = useState<ISaleRoDetail>({});
    const [descTotal, setDescTotal] = useState<ISaleRoStatistics>(initDesc);

    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [drawerVisible, setDrawerVisible] = useState(false);
    //选中的数据统计展示的数据
    const [rowsDescTotal, setRowsDescTotal] = useState<ISaleRoStatistics>(initDesc);
    const [descRows, setDescRows] = useState<ISaleRoDetail[]>([]);
    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedRow(selectedData as ISaleRoDetail)
    }, [selectedRowKeys])
    useEffect(() => {
        let newRowsDescTotal = initDesc
        descRows.forEach((item) => {
            let { totalNum, totalAmount, amountReceived } = item
            newRowsDescTotal.amount += +formatNum(totalAmount)
            newRowsDescTotal.amountReceived += +formatNum(amountReceived)
            newRowsDescTotal.totalAmount += +formatNum(totalAmount)
            newRowsDescTotal.totalNum += +formatNum(totalNum)
        })
        setRowsDescTotal(newRowsDescTotal)
    }, [descRows])
    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: ISaleRoSearch) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        loadData(initPgCfg, {});
        setSelectedRowKeys([])
    }
    const loadData = async (page?: ISearchPage, searchValue: ISaleRoSearch = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,

        }
        let { retData } = await saleRoService.page(searchParams);
        const { records, statistics, ...pg } = retData;
        setPgCfg(transPgToPagination({ ...pg, pageNum: pg.current }));
        setDataSource(records);
        setDescTotal(statistics);
    }
    const invalidateData = async (obj: object) => {
        let { retData } = await saleRoService.invalidate(obj)
        if (retData) {
            message.success("作废成功");
            loadData();
        }
    }
    const onPrinting = async (obj: object) => {
        let { retData } = await saleRoService.printing(obj)
        if (retData) {
            // message.success("作废成功");
            loadData();
        }
    }
    const [print, setPrint] = useState<boolean>(false);
    //列表导出
    const listExport = async () => {
        let result = await saleRoService.export({ ...searchParam, id: selectedRowKeys.join() });
        convertRes2Blob(result)
    }
    const detailsExport = async () => {
        let result = await saleRoService.detailsExport({
            ...searchParam,
            "pageSize": "0",
            "pageNum": "0",
            id: selectedRowKeys.join(),
        });
        convertRes2Blob(result)
    }
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        drawerVisible,
        selectedRow,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setDrawerVisible,
        invalidateData,
        setSelectedRow,
        print,
        setPrint,
        onPrinting,
        listExport,
        detailsExport,
        descTotal, setDescTotal,
        rowsDescTotal, setRowsDescTotal,
        descRows, setDescRows
    }
});